import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class CalculoAtuarialService extends Service {
  async consultarProcedimentosTitulares (filter) {
    let procedimentos = [];
    let result = await this.getCalculoAtuarialApi().consultarProcedimentosTitulares(filter);
    procedimentos = result;
    return procedimentos;
  }
  async consultarProcedimentosDependentes (filter) {
    let procedimentos = [];
    let result = await this.getCalculoAtuarialApi().consultarProcedimentosDependentes(filter);
    procedimentos = result;
    return procedimentos;
  }
  async consultarOpmesTitulares (filter) {
    let opmes = [];
    let result = await this.getCalculoAtuarialApi().consultarOpmesTitulares(filter);
    opmes = result;
    return opmes;
  }
  async consultarOpmesDependentes (filter) {
    let opmes = [];
    let result = await this.getCalculoAtuarialApi().consultarOpmesDependentes(filter);
    opmes = result;
    return opmes;
  }
  async consultarDespesasTitulares (filter) {
    let despesas = [];
    let result = await this.getCalculoAtuarialApi().consultarDespesasTitulares(filter);
    despesas = result;
    return despesas;
  }
  async consultarDespesasDependentes (filter) {
    let despesas = [];
    let result = await this.getCalculoAtuarialApi().consultarDespesasDependentes(filter);
    despesas = result;
    return despesas;
  }
  async consultarDespesasDependentes (filter) {
    let despesas = [];
    let result = await this.getCalculoAtuarialApi().consultarDespesasDependentes(filter);
    despesas = result;
    return despesas;
  }
  async consultarCalculoPrestadores (filter) {
    let prestadores = [];
    let result = await this.getCalculoAtuarialApi().consultarCalculoPrestadores(filter);
    prestadores = result;
    return prestadores;
  }
  async consultarCalculoUsuarios (filter) {
    let usuarios = [];
    let result = await this.getCalculoAtuarialApi().consultarCalculoUsuarios(filter);
    usuarios = result;
    return usuarios;
  }
  async consultarCalculoReceitas (filter) {
    let receitas = [];
    let result = await this.getCalculoAtuarialApi().consultarCalculoReceitas(filter);
    receitas = result;
    return receitas;
  }
  async consultarCalculoReembolsos (filter) {
    let reembolsos = [];
    let result = await this.getCalculoAtuarialApi().consultarCalculoReembolsos(filter);
    reembolsos = result;
    return reembolsos;
  }
  async consultarCovidAutorizacao (filter) {
    let covid = [];
    let result = await this.getCalculoAtuarialApi().consultarCovidAutorizacao(filter);
    covid = result;
    return covid;
  }
  async consultarCovidFaturamento (filter) {
    let covid = [];
    let result = await this.getCalculoAtuarialApi().consultarCovidFaturamento(filter);
    covid = result;
    return covid;
  }
}

export default CalculoAtuarialService;
